import { ThemeProvider } from '@emotion/react';
import { createTheme } from '@mui/material';
import { APIProvider } from '@vis.gl/react-google-maps';
import { ConnectedRouter } from 'connected-react-router';
import React from 'react';
import { Provider } from 'react-redux';
import { history, store } from 'store';

const theme = createTheme({
    typography: {
        fontFamily: ['Poppins', 'sans-serif'].join(',')
    }
});

const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';

const GoogleMapsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    if (!GOOGLE_MAPS_API_KEY) return <>{children}</>;

    return (
        <APIProvider apiKey={GOOGLE_MAPS_API_KEY} libraries={['places']}>
            {children}
        </APIProvider>
    );
};

export const AppProviders: React.FC<{ children: React.ReactNode }> = props => {
    return (
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <ThemeProvider theme={theme}>
                    <GoogleMapsProvider>{props.children}</GoogleMapsProvider>
                </ThemeProvider>
            </ConnectedRouter>
        </Provider>
    );
};
